<template>
  <div class="categoryManager">
    <div class="panel panel-default" v-for="categoryl1 in categories">
      <div class="panel-heading">
        <span v-text="categoryl1.name + '(' + categoryl1.goods_cnt + '个商品)'"></span>
        <i class="fa fa-trash pull-right"
            v-if="categoryl1.goods_cnt == 0 && categoryl1.items.length == 0"
            v-on:click="deleteCategoryL1(categoryl1.id)"></i>
        <i class="fa fa-edit pull-right" v-on:click="goCategoryL1Edit(categoryl1.id)"></i>
        <i class="fa fa-plus pull-right" v-on:click="goCategoryL2Create(categoryl1.id)"></i>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-sm-4 col-md-2" v-for="categoryl2 in categoryl1.items">
            <div class="thumbnail" v-on:click="goCategoryL2Detail(categoryl2.id)">
              <img v-bind:src="categoryl2.icon" alt="...">
              <div class="caption" v-text="categoryl2.text + '(' + categoryl2.goods_cnt + ')'">
              </div>
              <img class='deleteBtn' v-if="categoryl2.goods_cnt == 0" src='https://ogmcsrgk5.qnssl.com/vcdn/21841/小程序图标/删除.png' v-on:click.stop="deleteCategoryL2(categoryl2.id)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-primary" v-on:click="goCategoryL1Create">添加新的一级分类</button>
  </div>
</template>

<script>
import crudService from '../../service/crud.js'
import portalService from '../../service/portal.js'

export default {
  name: 'CategoryManager',
  props: {
  },
  components: {
  },
  data: function () {
    return {
      categories: []
    }
  },
  methods: {
    loadCategories: function () {
      let that = this
      this.portalService.loadCategories(function (data) {
        that.categories = data.categories
      })
    },
    goCategoryL2Detail: function (categoryl2Id) {
      this.$router.push('/categoryl2/detail/' + categoryl2Id)
    },
    goCategoryL1Edit: function (categoryl1Id) {
      this.$router.push('/categoryl1/update/' + categoryl1Id)
    },
    goCategoryL1Create: function () {
      this.$router.push('/categoryl1/create/')
    },
    goCategoryL2Create: function (categoryl1Id) {
      this.$router.push('/categoryl2/create/' + categoryl1Id)
    },
    deleteCategoryL1: function (categoryl1Id) {
      let that = this
      let r = confirm('确定要删除该一级分类么？')
      if (r) {
        let params = {categoryl1_id: categoryl1Id}
        this.categoryL1Service.deleteModel(params, function () {
          that.loadCategories()
        })
      }
    },
    deleteCategoryL2: function (categoryl2Id) {
      let that = this
      let r = confirm('确定要删除该二级分类么？')
      if (r) {
        let params = {categoryl2_id: categoryl2Id}
        this.categoryL2Service.deleteModel(params, function () {
          that.loadCategories()
        })
      }
    }
  },
  created: function () {
    this.categoryL1Service = new crudService.ModelService('emarket', 'categoryl1', 1)
    this.categoryL2Service = new crudService.ModelService('emarket', 'categoryl2', 1)
    this.portalService = new portalService.PortalService()
    this.loadCategories()
  }
}
</script>
<style scoped>
.categoryManager {
  padding: 20px;
}
.caption {
  text-align: center;
}
i.fa {
  cursor: pointer;
  font-size: 16px;
  margin-top: 4px;
  margin-right: 4px;
}
.thumbnail {
  cursor: pointer;
  position: relative;
}
.deleteBtn {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// CategoryManager.vue?027160be